
import { api } from "../../../utils/api";
// {
//   "enterprise_id": 0,
//   "parent_id": "string", folder id
//   "files": [
//     {
//       "name": "string",
//       "desc": "string",
//       "file": "string"
//     }
//   ]
// }
export const postEnterpriseDrive = async (data) => {
  try {
    const response = await api.post(`drive`, data);
    return response.data;
  } catch (error) {
    throw new Error(error.data.error);
  }
};
